














































import Vue from "vue";
import { Component, Prop } from 'vue-property-decorator';
import { mapState } from "vuex";
import draggable from "vuedraggable";
import TreeItem from "@/components/NodeTree/TreeItem.vue";
import NavNode from "@/services/NavigationNode";

@Component({
	computed: {
		...mapState(["expanded"]),
	},
	components: {
		draggable,
		TreeItem,
	}
})
export default class NavPanel extends Vue {
	@Prop() items!: NavNode[];
	@Prop({ default: false }) ro!: boolean;

	expanded!: boolean;

	get openAll() {
		return this.expanded;
	}
	set openAll(value) {
		this.$store.dispatch('setExpanded', value);
	}
	cloned(e: NavNode) {
		// for sorting to trigger Properties panel, could be better.
		this.$store.dispatch("setSelected", e.uid);
	}

	// used by v-click-outside directive. 
	propertiesEl() {
		return [(this.$parent.$refs.properties as Vue).$el];
	}
	
	// can remove when "selected" nodeTree item is highlighted.
	onClickOutside() {
		this.$store.dispatch("unsetSelected");
	}
}
